import { cn } from "@repo/ui/lib/utils";

export function OptionsGrid({ children }: { children: React.ReactNode }) {
  const className = cn(
    "w-full",
    "flex gap-4 flex-wrap",
    "[&>*]:h-[14rem] [&>*]:min-w-[18rem] [&>*]:flex-1"
  );

  return <div className={className}>{children}</div>;
}
